<div class="device-list-container">
  <div class="loading-overlay" *ngIf="isLoading">
    <mat-progress-spinner mode="indeterminate" diameter="50">
    </mat-progress-spinner>
  </div>
  <div class="filter-container" [formGroup]="filters">
    <mat-expansion-panel [(expanded)]="showTypes" class="device-expansion-panel" *ngIf="multiType">
      <mat-expansion-panel-header class="filter-header" matRipple>
        <p class="title no-select"><mat-icon
            class="title-icon material-icons-outlined">category_outlined</mat-icon>{{'devices.title.deviceTypes' |
          translate}}</p>
      </mat-expansion-panel-header>
      <div class="device-type-filter-container">
        <mat-chip-listbox id="externalDeviceTypeCode" formControlName="externalDeviceTypeCode" multiple
          aria-label="Device type selection">
          <button class="status-clear-button clear-button-SZT" mat-icon-button
            (click)="showStatusChips = !showStatusChips" *ngIf="sztFilterOn" matTooltipClass="type-tooltip-SZT"
            [matTooltip]="'devices.table.' + (showStatusChips ? 'hide-status' : 'show-status') | translate"
            [matTooltipShowDelay]="1000">
            <mat-icon class="material-icons-outlined" *ngIf="!showStatusChips">
              filter_list
            </mat-icon>
            <mat-icon class="material-icons-outlined" *ngIf="showStatusChips">
              filter_list_off
            </mat-icon>
          </button>
          <mat-chip-option *ngFor="let deviceType of deviceTypes" [value]="deviceType"
            [ngClass]="'color-'+ DeviceTypeKeys[deviceType]" class="type-chip" selected matRipple
            [matTooltip]="'devices.table.device-count' | translate : { count: getCountByType(deviceType)}"
            [matTooltipClass]="typeSelected(deviceType) ? 'type-tooltip-' + DeviceTypeKeys[deviceType] : 'clear-tooltip'"
            [matTooltipShowDelay]="500">
            {{DeviceTypes[deviceType].translateString | translate}}
          </mat-chip-option>
          <button class="clear-button" mat-icon-button color="none" (click)="clearChips()" [matTooltipShowDelay]="1000"
            [matTooltip]="'devices.table.' + (isFullChips() ? 'remove-filters' : 'restore-filters') | translate">
            <mat-icon>{{ isFullChips() ? 'clear' : 'refresh'}}</mat-icon>
          </button>
        </mat-chip-listbox>
        <mat-chip-listbox id="deviceStatusListbox" formControlName="deviceStatusListbox"
          class="device-status-list-box color-SZT" multiple aria-label="Device status type selection"
          *ngIf="sztFilterOn && showStatusChips" [@appear]>
          <mat-chip-option *ngFor="let status of StatusKeys" [value]="status" [ngClass]="'status-color-'+ status"
            class="type-chip" selected matRipple
            [matTooltip]="'devices.table.device-count' | translate : { count: getCountByStatus(status)}"
            [matTooltipClass]="statusSelected(status) ? 'status-tooltip-' + status : 'clear-tooltip'"
            [matTooltipShowDelay]="500">
            {{'devices.status.' + status | translate}}
          </mat-chip-option>
          <button class="clear-button" mat-icon-button color="none" (click)="clearChips('deviceStatusListbox')"
            [matTooltipShowDelay]="1000" matTooltipClass="type-tooltip-SZT"
            [matTooltip]="'devices.table.' + (isFullChips('deviceStatusListbox') ? 'remove-filters' : 'restore-filters') | translate">
            <mat-icon>{{ isFullChips('deviceStatusListbox') ? 'clear' : 'refresh'}}</mat-icon>
          </button>
        </mat-chip-listbox>
      </div>
    </mat-expansion-panel>
    <div class="main-filter-container">
      <button class="filter-refresh-button" mat-button (click)="loadDevices()" [disabled]="isLoading"
        matTooltipClass="clear-tooltip" [matTooltipShowDelay]="500"
        [matTooltip]="'devices.table.refresh-devices' | translate">
        <mat-icon>sync</mat-icon>
      </button>
      <mat-expansion-panel class="device-expansion-panel">
        <mat-expansion-panel-header class="filter-header with-refresh" matRipple>
          <p class="title no-select"><mat-icon class="title-icon">filter_list</mat-icon>{{'devices.title.filters' |
            translate}}</p>
          <button class="filter-select-menu" (click)="$event.stopPropagation()" mat-icon-button #matMenuTrigger
            [matMenuTriggerFor]="filterMenu" aria-label="Filter select menu"
            [matTooltip]="'devices.table.more-filters' | translate" matTooltipClass="clear-tooltip">
            <mat-icon>tune</mat-icon>
          </button>
          <mat-menu #filterMenu="matMenu">
            <div class="filter-menu-check-item">
              <mat-checkbox class="filter-menu-checkbox" color="primary" (click)="$event.stopPropagation()"
                [checked]="allFilterChecked" [indeterminate]="anyFilterChecked"
                (change)="menuFilterAllSelect($event.checked)">{{
                'devices.table.header.all' | translate }}
              </mat-checkbox>
            </div>
            <mat-divider></mat-divider>
            <div class="filter-menu-check-item" formArrayName="filterItems" *ngFor="let item of filterItems">
              <mat-checkbox *ngIf="showFilterItem(item)" class="filter-menu-checkbox" color="primary"
                [formControlName]="item.index" (click)="$event.stopPropagation()" (change)="menuFilterSelect()">{{
                'devices.table.header.' +
                item.translate | translate }}
              </mat-checkbox>
            </div>
          </mat-menu>
        </mat-expansion-panel-header>
        <div class="main-filter-list">
          <ng-container *ngFor="let item of filterItems; let i = index;">
            <mat-form-field appearance="outline" class="device-form-field" [ngStyle]="{ flex: filterItemFlexStyle }"
              *ngIf="item.control === 'logisticStatus' && showFilterItem(item) && isFilterActive(i)">
              <mat-label>{{'devices.table.header.' + item.translate | translate}}</mat-label>
              <input type="text" matInput [formControlName]="item.control" [matAutocomplete]="logAuto" maxlength="20">
              <mat-autocomplete autoActiveFirstOption #logAuto="matAutocomplete">
                <mat-option *ngFor="let logValue of logValuesObservable | async" [value]="logValue"
                  [matTooltip]="'devices.table.device-count' | translate : { count: countByLogisticStatus(logValue)}"
                  matTooltipPosition="left">
                  {{logValue}}
                </mat-option>
              </mat-autocomplete>
              <button [ngStyle]="{'visibility': emptyFilter(item.control) ? 'hidden' : 'visible'}" matSuffix
                mat-icon-button aria-label="Clear" (click)="clearFilter(item.control, $event)">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
            <mat-form-field appearance="outline" class="device-form-field" [ngStyle]="{ flex: filterItemFlexStyle }"
              *ngIf="item.control !== 'logisticStatus' && showFilterItem(item) && isFilterActive(i)">
              <mat-label>{{'devices.table.header.' + item.translate | translate}}</mat-label>
              <input matInput [formControlName]="item.control" (click)="$event.stopPropagation()"
                (keydown)="$event.stopPropagation()">
              <button [ngStyle]="{'visibility': emptyFilter(item.control) ? 'hidden' : 'visible'}" matSuffix
                mat-icon-button aria-label="Clear" (click)="clearFilter(item.control, $event)">
                <mat-icon>close</mat-icon>
              </button>
            </mat-form-field>
          </ng-container>
        </div>
        <mat-expansion-panel [(expanded)]="showSort" class="device-expansion-panel">
          <mat-expansion-panel-header class="filter-header" matRipple>
            <p class="title no-select"><mat-icon class="title-icon">sort</mat-icon>{{'devices.title.sort' |
              translate}}</p>
          </mat-expansion-panel-header>
          <table matSort (matSortChange)="sortData($event)" class="device-sort" aria-label="Device sort">
            <tr class="device-sort-list">
              <th class="device-sort-item no-select" mat-sort-header="externalDeviceTypeCode" *ngIf="multiType">
                {{'devices.table.header.ext-device-type-code' | translate}}
              </th>
              <th class="device-sort-item no-select" mat-sort-header="externalDeviceId">
                {{'devices.table.header.ext-device-id' |
                translate}}</th>
              <th class="device-sort-item no-select" mat-sort-header="deviceId">{{'devices.table.header.device-id' |
                translate}}
              </th>
              <th *ngIf="expandSort && isDistinctByAttr('gateFactorySn')" class="device-sort-item no-select"
                mat-sort-header="gateFactorySn">{{'devices.table.header.factory-sn'
                |
                translate}}
              </th>
              <th *ngIf="expandSort && multiCustomer" class="device-sort-item no-select" mat-sort-header="customerName">
                {{'devices.table.header.customer-name' |
                translate}}
              </th>
              <th *ngIf="expandSort && isDistinctByAttr('logisticStatus')" class="device-sort-item no-select"
                mat-sort-header="logisticStatus">
                {{'devices.table.header.logistic-status' |
                translate}}
              </th>
              <th *ngIf="expandSort && isDistinctByAttr('logisticStatusDesc')" class="device-sort-item no-select"
                mat-sort-header="logisticStatusDesc">
                {{'devices.table.header.logistic-status-desc' |
                translate}}
              </th>
              <th class="device-sort-item no-select" mat-sort-header="operationStatus"
                *ngIf="expandSort && sztFilterOn">
                {{'devices.table.header.operation-status' |
                translate}}
              </th>
              <button *ngIf="!expandSort && mobile" class="sort-more-button" mat-button (click)="expandSort = true"
                matTooltipClass="clear-tooltip" [matTooltipShowDelay]="500"
                [matTooltip]="'devices.table.more-sort' | translate">
                <mat-icon>more_horiz</mat-icon>
              </button>
            </tr>
          </table>
        </mat-expansion-panel>
      </mat-expansion-panel>
    </div>
  </div>
  <mat-divider></mat-divider>
  <div class="card-container">
    <div class="no-record-container" *ngIf="this.devices.filteredData.length === 0">
      <p>{{'table.no-records' | translate}}</p>
    </div>
    <div *ngFor="let device of deviceObserver | async">
      <app-device-card [device]="device" [multiCustomer]="multiCustomer"></app-device-card>
    </div>
  </div>
  <mat-divider></mat-divider>
  <mat-paginator #deviceListPaginator [pageSizeOptions]="[10, 25, 50, 100, deviceListPaginator.length]"
    [showFirstLastButtons]="!mobile" [hidePageSize]="mobile">
  </mat-paginator>
</div>
